export default __webpack_public_path__ + "static/media/antd.78492f0a.less";